const WorkforceIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89196)">
      <path
        d="M0.00683589 13.07C-0.0583204 13.5943 0.350605 14.0573 0.879004 14.0573H4.45475C4.88394 14.0573 5.25039 13.7472 5.32146 13.3239C6.00965 9.22557 9.22551 6.00965 13.3238 5.32152C13.7472 5.25045 14.0572 4.884 14.0572 4.45475V0.879004C14.0572 0.350605 13.5943 -0.0583204 13.0699 0.00683589C9.77283 0.416582 6.6581 1.94113 4.29959 4.29959C1.94113 6.6581 0.416582 9.77283 0.00683589 13.07Z"
        fill="white"
      />
      <path
        d="M20.6001 22.8914C18.932 24.0825 16.9759 24.7121 14.9435 24.7121C10.161 24.7121 6.11441 21.2849 5.32152 16.563C5.25045 16.1397 4.884 15.8296 4.4548 15.8296H0.879004C0.350605 15.8296 -0.0583204 16.2925 0.00683589 16.8168V16.8169C0.940879 24.3325 7.36223 30 14.9435 30C18.3208 30 21.5148 28.9038 24.1801 26.8299C24.5973 26.5053 24.6356 25.8885 24.2618 25.5147L21.7323 22.9852C21.4285 22.6815 20.9497 22.6418 20.6001 22.8914Z"
        fill="white"
      />
      <path
        d="M16.5615 5.32152C21.2834 6.11441 24.7107 10.161 24.7107 14.9435C24.7107 16.9759 24.0811 18.9319 22.8901 20.6001C22.6405 20.9497 22.6801 21.4285 22.9839 21.7323L25.5135 24.2619C25.8873 24.6357 26.504 24.5973 26.8286 24.1802L26.8286 24.1801C28.9024 21.5149 29.9986 18.3209 29.9986 14.9435C29.9986 7.36223 24.3311 0.940879 16.8155 0.00683589H16.8154C16.2911 -0.0583204 15.8281 0.350605 15.8281 0.879004V4.45475C15.8282 4.884 16.1382 5.25045 16.5615 5.32152Z"
        fill="white"
      />
      <path
        d="M15.528 8.90405H14.3555C13.8701 8.90405 13.4766 9.29757 13.4766 9.78296V20.0367H16.407V9.78296C16.407 9.29757 16.0134 8.90405 15.528 8.90405Z"
        fill="white"
      />
      <path
        d="M18.1641 20.0368H20.2155C20.7009 20.0368 21.0945 19.6433 21.0945 19.1579V12.1267C21.0945 11.6413 20.7009 11.2478 20.2155 11.2478H18.1641V20.0368Z"
        fill="white"
      />
      <path
        d="M11.7172 13.5916H9.66797C9.18258 13.5916 8.78906 13.9851 8.78906 14.4705V19.1579C8.78906 19.6433 9.18258 20.0368 9.66797 20.0368H11.7172V13.5916Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89196">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default WorkforceIcon
